"use strict";

function _createForOfIteratorHelper(e, t) {
  var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = _unsupportedIterableToArray(e)) || t && e && "number" == typeof e.length) {
      r && (e = r);
      var n = 0,
        l = function () {};
      return {
        s: l,
        n: function () {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: l
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a,
    o = !0,
    i = !1;
  return {
    s: function () {
      r = r.call(e);
    },
    n: function () {
      var e = r.next();
      return o = e.done, e;
    },
    e: function (e) {
      i = !0, a = e;
    },
    f: function () {
      try {
        o || null == r.return || r.return();
      } finally {
        if (i) throw a;
      }
    }
  };
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
  }
}
function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}
var CLASS_NAME = "PropertyInfo:",
  bedBathSqftArray = ["bed", "bath", "sqft"],
  META_PROPERTY_ARRAY = ["og:street-address", "og:locality", "og:region", "og:postal-code"],
  ZILLOW_META_PROPERTY_ARRAY = ["og:zillow_fb:address"],
  LI_DATA_LABELS = ["pc-meta-sqft"],
  PropertyInfo = function () {
    return _createClass(function e() {
      _classCallCheck(this, e);
    }, [{
      key: "sayHello",
      value: function () {
        console.log("propertyInfo : Hello ");
      }
    }, {
      key: "getListingPriceFromRealtor",
      value: function () {
        var e,
          t = "0",
          r = document.querySelectorAll("div.list-price");
        r.length > 0 && "DIV" === r[0].tagName && null != (r = r[0].querySelectorAll("div"))[0] && (t = r[0].innerText);
        var n = document.getElementsByClassName("listing-information-cmp");
        if ("0" !== t && n.length > 0) {
          n = n[0];
          for (var l = 0; l < n.childNodes.length; l++) if (n.childNodes[l].className.includes("price-section")) {
            for (var a = n.childNodes[l], o = 0; o < a.childNodes.length; o++) a.childNodes[o].className.includes("price") && (t = a.childNodes[o].innerText);
            break;
          }
        } else {
          n = document.getElementsByTagName("span");
          for (l = 0; l < n.length; l++) if (n[l].getAttribute("content")) {
            t = n[l].getAttribute("content");
            break;
          }
        }
        return e = t.replace("$", "").replace(/,/g, ""), console.log("propertyInfo : getListingPriceFromRealtor : ", e), e;
      }
    }, {
      key: "getListingPriceFromZillow",
      value: function () {
        var e = document.getElementsByClassName("zestimate-value"),
          t = "";
        try {
          e.length > 0 ? (console.log("@@@----\x3eListing elem If", e), t = (e = e[0]).innerText) : (e = document.getElementsByClassName("einFCw"), console.log("@@@----\x3eListing elem Else", e), t = (e = e[0]).innerText);
        } catch (e) {
          console.log("@@@-------\x3e in catch");
        }
        return t.replace("$", "").replace(/,/g, "").replace(/\D/g, "");
      }
    }, {
      key: "getAddressFromRealtor",
      value: function (e) {
        for (var t, r = document.getElementsByTagName("meta"), n = [], l = 0; l < r.length; l++) META_PROPERTY_ARRAY.includes(r[l].getAttribute("property")) && (console.log("~~:metas[i]: ", r[l], ":getAddressFromRealtor:", CLASS_NAME), n[r[l].getAttribute("property")] = r[l].getAttribute("content"));
        var a,
          o = [],
          i = _createForOfIteratorHelper(META_PROPERTY_ARRAY);
        try {
          for (i.s(); !(a = i.n()).done;) if (null != n[t = a.value]) {
            var s = n[t].trim();
            o.push(s);
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        var c = document.getElementsByClassName("new-home-address");
        return c.length > 0 && (console.log("@@@---\x3eSales Office: ", c[0].innerText), c[0].innerText.includes("Sales Office")) ? "" : o.join(" ");
      }
    }, {
      key: "getAddressFromZillow",
      value: function (e) {
        for (var t = document.getElementsByTagName("meta"), r = [], n = 0; n < t.length; n++) ZILLOW_META_PROPERTY_ARRAY.includes(t[n].getAttribute("property")) && (console.log("~~:metas[i]: ", t[n], ":getAddressFromZillow:", CLASS_NAME), r[t[n].getAttribute("property")] = t[n].getAttribute("content"));
        return r["og:zillow_fb:address"];
      }
    }, {
      key: "getBedBathFromRealtor",
      value: function () {
        console.log("@@@---\x3e", ":getBedBathFromRealtor:");
        var e,
          t,
          r = "",
          n = {},
          l = ["pc-meta-beds", "pc-meta-baths", "pc-meta-sqft", "property-meta-beds", "property-meta-bath", "property-meta-sqft"],
          a = document.querySelectorAll("ul.property-meta");
        0 === a.length && (a = document.querySelectorAll("li[data-testid]")), a.length > 0 && "UL" === a[0].tagName && (a = a[0].querySelectorAll("li"));
        for (var o = 0; o < a.length; o += 1) if (e = a[o], t = a[o].innerHTML, console.log("~~----\x3einnerHTML:", t), "property-meta-beds" === e.getAttribute("data-testid") || "property-meta-beds" === e.getAttribute("data-label")) {
          var i = e.innerText;
          null != i ? (i = i.replace("\nbeds", "").replace(",", ""), n.bed = i) : n.bed = "1";
        } else if ("property-meta-bath" === e.getAttribute("data-testid") || "property-meta-bath" === e.getAttribute("data-label")) {
          var s = e.innerText;
          null != s ? (s = s.replace("\nbath", "").replace(",", ""), n.bath = s) : n.bath = "1";
        } else if ("property-meta-sqft" === e.getAttribute("data-testid") || "property-meta-sqft" === e.getAttribute("data-label")) {
          var c = e.innerText;
          null == c || !c.includes("sq ft") && !c.includes("sqft") || c.includes("sqft lot") || (c = c.replace("\nsqft", "").replace(",", ""), n.sqft = c);
        } else if (t.includes("<span data-testid")) if (t.includes("beds")) {
          var u = t.split(">");
          u.length > 1 ? (u = u[1].split("<"), n.bed = u[0]) : n.bed = "1";
        } else if (t.includes("bath")) {
          var d = t.split(">");
          d.length > 1 ? (d = d[1].split("<"), n.bath = d[0]) : n.bath = "1";
        } else if ((t.includes("sq ft") || t.includes("sqft")) && !t.includes("sqft lot")) {
          var f = t.split(">");
          f.length > 1 ? (f = f[1].split("<"), n.sqft = f[0]) : n.sqft = "1000";
        }
        if (n.sqft || (n.sqft = "1000"), 0 === a.length) for (var g = document.querySelectorAll("li"), p = 0; p < g.length; p++) if (g[p].getAttribute("data-label") && l.includes(g[p].getAttribute("data-label")) && null != g[p].children && g[p].children.length > 0) {
          r = r + g[p].children[0].innerText + " 0";
          var h = g[p].getAttribute("data-label");
          h = -1 !== (h = -1 !== (h = -1 !== h.indexOf("bed") ? "bed" : h).indexOf("bath") ? "bath" : h).indexOf("sqft") ? "sqft" : h;
          var m = g[p].children[0].innerText.replace(/,/g, "");
          -1 !== m.indexOf(".") && (m = m.replace(".", "!")), void 0 === m && (m = 0), n[h] = m;
        }
        for (var b = document.getElementsByClassName("ellipsis"), y = null, A = 0; A < b.length; A++) if (b[A].children.length > 1 && b[A].children[0].innerText.includes("Year Built") && "" !== b[A].children[1].innerText) {
          console.log("@@@----\x3eYear Built Found", b[A].children[1].innerText), y = b[A].children[1].innerText;
          break;
        }
        for (var v = [], T = 0, q = 0; q < bedBathSqftArray.length; q += 1) T = /\d/.test(n[bedBathSqftArray[q]]) ? n[bedBathSqftArray[q]] : 0, v.push(T);
        var _ = this.getListingPriceFromRealtor();
        return null != _ && v.push(_), y || (y = 1970), v.push(y), console.log("@@@---tempArray: ", v, " # tempArray.join: ", v.join(".")), v.join(".");
      }
    }, {
      key: "getBedBathFromZillow",
      value: function () {
        var e = document.getElementsByClassName("ds-bed-bath-living-area-container");
        if (0 === e.length) return "";
        e = e[0];
        for (var t = {}, r = 0; r < e.children.length; r++) {
          var n = e.children[r].innerText.split(" ");
          if (null != n) {
            var l = null != n[1] && "bd" === n[1] ? "bed" : null;
            l = null == l && null != n[1] && "ba" === n[1] ? "bath" : l, l = null != n[1] && "sqft" === n[1] ? "sqft" : l;
            var a = n[0].replace(/,/g, "");
            void 0 === a && (a = 0), t[l] = a;
          }
          0;
        }
        for (var o = document.getElementsByClassName("hqfqED"), i = null, s = 0; s < o.length; s++) if (o[s].innerText.includes("Year built")) {
          console.log("@@@----\x3eYear Built Found", o[s].innerText), i = (i = o[s].innerText).replace("Year", "").replace("built", "").replace(":", "").replace(/\s/g, "");
          break;
        }
        for (var c = [], u = 0, d = 0; d < bedBathSqftArray.length; d += 1) u = /\d/.test(t[bedBathSqftArray[d]]) ? t[bedBathSqftArray[d]] : 0, c.push(u);
        var f = this.getListingPriceFromZillow();
        return null != f && c.push(f), console.log("@@@----\x3eYear Built Found", i), i || (i = 1970), c.push(i), console.log("@@@---tempArray: ", c, " # tempArray.join: ", c.join(".")), c.join(".");
      }
    }, {
      key: "getLivingArea",
      value: function () {
        for (var e = ":getLivingArea:", t = document.querySelectorAll("li"), r = "", n = 0; n < t.length; n++) {
          if (console.log("~~lis[i]: ", t[n], e, CLASS_NAME), t[n].getAttribute("className").startsWith("jsx-") && LI_DATA_LABELS.includes(t[n].getAttribute("data-labels"))) console.log("~~:lis[i]: ", t[n], e, CLASS_NAME), r = t[n].firstChild.innerHTML;
        }
        return console.log("~~:livingArea: ", r, e, CLASS_NAME), r;
      }
    }]);
  }();
module.exports = {
  PropertyInfo: PropertyInfo
};